import type { ReactNode } from 'react';
import { Icon, UtilityButton } from '@kinesis/bungle';

// The download trigger with its in-flight affordance: while `downloading`,
// the download glyph swaps for bungle's rotating spinner and the button
// disables until the mutation settles — the `loading` idiom bungle's
// `Button` has built in but `UtilityButton` lacks. Every download button
// renders through this so the affordance stays uniform.
const DownloadButton = (props: DownloadButtonProps) => {
  const {
    children,
    downloading = false,
    magnitude = 'medium',
    onClick,
  } = props;
  return (
    <UtilityButton
      disabled={downloading}
      icon={
        downloading ? (
          <Icon animation='rotate' magnitude={magnitude} type='spinner' />
        ) : (
          'download'
        )
      }
      magnitude={magnitude}
      onClick={onClick}
    >
      {children}
    </UtilityButton>
  );
};

export type DownloadButtonProps = {
  // The download is in flight — spinner + disabled until it settles.
  downloading?: boolean;
  magnitude?: 'medium' | 'small' | 'xsmall';
  onClick?: () => void;
  children?: ReactNode;
};

export { DownloadButton };
